module.exports = __webpack_public_path__ + "static/media/img5.4748d56e.png";